import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
(function () {
  const _0x72a = ["YWJoaXNoZWsgamFpbg==", "Y29udGV4dG1lbnU=", "Y29uc29sZQ=="];
  const _0x3b1 = s => atob(s);
  const _signature = _0x3b1(_0x72a[0]);

  Object.defineProperty(window, '_created_by', {
    get: function () {
      console.log(
        "%c Staffing Management System %c " + _signature.toUpperCase() + " ",
        "background: #2C1A10; color: #EAD7BB; padding: 5px 10px; border-radius: 5px 0 0 5px; font-weight: bold;",
        "background: #C0722C; color: #fff; padding: 5px 10px; border-radius: 0 5px 5px 0; font-weight: bold;"
      );
      return `Authorized System Developer: ${_signature}`;
    },
    configurable: false
  });
})();
reportWebVitals();
